import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`

    @font-face {
        font-family: Moby;
        src: url("./fonts/MOBY-REG.ttf")
    }

    :root {
        --background: #000000;
        --background-header: #F7F7F7;
        --background-one: #05050F;
        --background-two: #0F0F19;
        --background-three: #1E1E28;
        --background-four: #00A79E;
        --background-season-2:  #D07BBE;
        --bottom: #FAFAFA;

        --text-title: #FFFFFF;
        --text-subtitle: #05050F;
        --text-body: #FAFAFA;
        --text-pink: #D07BBE;

        --aqua: #00C2B7;
        --button-count: #01AFA5;

    }
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        @media (max-width: 1080px) {
            font-size: 93.75%;
        }
        @media (max-width: 720px) {
            font-size: 87.5%;
        }
    }

    body {
        background: var(--background);
        overflow-x:hidden;
        -webkit-font-smoothing: antialiased;
        font-family: 'Graphik';
    }
    a {
        text-decoration: none;
    }
    h1, h2 {
        font-family: "Moby";
    }
    li {
        list-style: none;
    }
`